import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import TableOfContent from '../table-of-contents';
import RichText from '../rich-text';
import { BlockTitle, BlockContent } from '../table-of-contents/styles';
import { Container, TwoThirds } from '../styled/containers';
import { sanitizeId, consistentString } from '../../utils/content-formatting';
import { VisuallyHidden } from '../styled/accessibility';

import { useLayout } from '../layout/context';
import Assembly from '../assemblies/component';

const JumpMenuWithContent = ({ listType = 'bullets', contentBlocks = [] }) => {
  const { insideContainer, insideTwoThirds } = useLayout();

  const OuterWrapper = insideContainer ? React.Fragment : Container;
  const InnerWrapper = insideTwoThirds ? React.Fragment : TwoThirds;

  const isBulletedList = consistentString(listType) === 'bullets'; // true = bulleted list, false = numbered list

  return (
    <OuterWrapper $padding={!insideContainer}>
      <InnerWrapper>
        <TableOfContent
          isBulletedList={isBulletedList}
          tableOfContents={contentBlocks}
        />
        {contentBlocks.map(({ title, bodyText, assemblies }, i) => (
          <Fragment key={`contentBlock_${i}`}>
            <BlockTitle id={sanitizeId(title)}>
              {/* To programmatically render the numbering if it is a numbered list */}
              {isBulletedList ? (
                ''
              ) : (
                <>
                  <VisuallyHidden>Step</VisuallyHidden>
                  {i + 1}
                  <span aria-hidden="true">. </span>
                </>
              )}
              {title}
            </BlockTitle>
            <BlockContent>
              <RichText richText={bodyText} />
              {assemblies &&
                assemblies.map((assembly) => (
                  <Assembly assembly={assembly} key={assembly.contentful_id} />
                ))}
            </BlockContent>
          </Fragment>
        ))}
      </InnerWrapper>
    </OuterWrapper>
  );
};

JumpMenuWithContent.propTypes = {
  listType: PropTypes.string,
  contentBlocks: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      bodyText: PropTypes.shape({
        json: PropTypes.object,
      }),
      assemblies: PropTypes.array,
    })
  ),
};

export default JumpMenuWithContent;

export const JumpMenuWithContentAssembly = ({ contentfulData }) => (
  <JumpMenuWithContent
    listType={contentfulData.listType}
    contentBlocks={contentfulData.contentBlocks}
  />
);

JumpMenuWithContentAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
